import Axios from "axios";
import { useAuth } from "../providers/AuthProvider";
import { API_CONFIG } from "./apiConfig";

// Create axios instance with configuration
const axiosBaseURL = Axios.create({
  // baseURL: API_CONFIG.baseURL,
  // baseURL: "https://shegafre.dev.kifiya.et/dagri/api/",
  // baseURL: "http://10.254.99.51:8080/dagri/api/",
  baseURL: "https://fe.shegafre.com/dagri/api/",
  // baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Access-Control-Allow-Origin": "*",
  },
});

// Flag to prevent multiple refresh requests
let isRefreshing = false;
let refreshSubscribers: ((token: string) => void)[] = [];

// Function to notify subscribers with the new token
const onRefreshed = (token: string) => {
  refreshSubscribers.forEach((callback) => callback(token));
  refreshSubscribers = [];
};

// ** Request Interceptor ** (Attach Required Headers)
axiosBaseURL.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    if (token && userId) {
      if (!config.headers) {
        config.headers = new Axios.AxiosHeaders();
      }

      config.headers.set("Authorization", `Bearer ${token}`);
      config.headers.set("header", `${userId}/${token}`);
    }

    return config;
  },
  (error) => Promise.reject(error),
);

// ** Token Refresh Function **
const refreshAuthToken = async () => {
  try {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) return null;

    const response = await axiosBaseURL.post("/auth/refresh", { refreshToken });

    if (response.status === 200 && response.data.token) {
      localStorage.setItem("token", response.data.token);
      return response.data.token;
    }
  } catch (error) {
    console.error("Failed to refresh token:", error);
  }
  return null;
};

// ** Response Interceptor ** (Handle Token Expiry & Refresh)
axiosBaseURL.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve) => {
          refreshSubscribers.push((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            originalRequest.headers.header = `${localStorage.getItem(
              "userId",
            )}/${token}`;
            resolve(axiosBaseURL(originalRequest));
          });
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const newToken = await refreshAuthToken();
        if (newToken) {
          axiosBaseURL.defaults.headers.Authorization = `Bearer ${newToken}`;
          axiosBaseURL.defaults.headers.header = `${localStorage.getItem(
            "userId",
          )}/${newToken}`;
          onRefreshed(newToken);
          return axiosBaseURL(originalRequest); // Retry the failed request
        }
      } catch (err) {
        console.error("Token refresh failed, logging out...");
        const { logout } = useAuth() || {};
        if (logout) logout();
      } finally {
        isRefreshing = false;
      }
    }
    return Promise.reject(error);
  },
);

export default axiosBaseURL;
